import SocketContext, { SocketRef } from "./context";

const SocketManager = {
  Portal: () => <SocketContext ref={SocketRef} />,
  subscribe: (topic, listener) => {
    SocketRef.current.subscribe(topic, listener);
  },
  connectStaffSocket: (staffId) => {
    SocketRef.current.connectStaffSocket(staffId);
  },
};

export default SocketManager;
